import { Component } from '@angular/core';

@Component({
  selector: 'app-community-page',
  templateUrl: './community-page.component.html',
  styleUrls: ['./community-page.component.scss'],
})
export class CommunityPageComponent {
  showModal = false;
  modalImage = '';

  openModal(image: string) {
    this.modalImage = image;
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
    this.modalImage = '';
  }
}
